import React from 'react';

function EcoFriendlySection() {
  return (
    <div 
      className="tw-self-center tw-mt-28 tw-mx-auto tw-w-full tw-px-4"
      style={{maxWidth: "1293px"}}>
      <div className="tw-flex tw-flex-col md:tw-flex-row tw-gap-5">
        <div 
          className="tw-flex tw-flex-col md:ml-0 md:w-full"
          style={{maxWidth: "500px"}}>
          <div className="tw-flex tw-flex-col tw-self-stretch tw-my-auto md:mt-10 md:max-w-full">
            <h1 className="tw-capitalize tw-text-5xl md:tw-text-6xl tw-leading-[67px] tw-text-neutral-700 md:max-w-full md:text-4xl md:leading-[54px] sm:px-6">
              We're committed to a quality & sustainable offering
            </h1>
            <p className="tw-mt-4 tw-text-xl tw-leading-6 tw-text-neutral-800 md:max-w-full sm:px-6">
              We only carry products that are eco-friendly, non-toxic and
              ethically made & sourced so that you're in only the best company.
            </p>
          </div>
        </div>
        <div className="tw-flex tw-ml-5 md:ml-0 md:w-full">
          <img
            src="https://expertpeople.imgix.net/assets/images/forbrands-sustainable.png?auto=format"
            className="tw-object-contain tw-grow tw-w-full tw-aspect-[1.54] md:mt-10 md:max-w-full"
            alt="Eco-friendly products showcase"
          />
        </div>
      </div>
      <div className="scrolling-container tw-flex tw-mt-10 tw-flex tw-flex-col md:tw-flex-row tw-gap-5 tw-mt-20 md:tw-mt-32">
        <div className="scrolling-content" style={{width: "fit-content"}}>
          { [...Array(5)].map((_, i) => (
            <img
              src="https://expertpeople.imgix.net/assets/images/forbrands-brands.png?auto=format"
              alt="Eco-friendly products showcase"
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default EcoFriendlySection;
